/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../../common";
import type {
  CarRentalUpgradeable,
  CarRentalUpgradeableInterface,
} from "../../contracts/CarRentalUpgradeable";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "InvalidInitialization",
    type: "error",
  },
  {
    inputs: [],
    name: "NotInitializing",
    type: "error",
  },
  {
    inputs: [],
    name: "ReentrancyGuardReentrantCall",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "version",
        type: "uint64",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "rentalId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "renter",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "RentalCancelled",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "rentalId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "renter",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "RentalCompleted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "rentalId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "renter",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "totalAmount",
        type: "uint256",
      },
    ],
    name: "RentalInitiated",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "rentalId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "hoursLate",
        type: "uint256",
      },
    ],
    name: "calculateLateFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "rentalId",
        type: "uint256",
      },
    ],
    name: "cancelRental",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "chaindriveWallet",
    outputs: [
      {
        internalType: "address payable",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "rentalId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "hoursLate",
        type: "uint256",
      },
    ],
    name: "completeRentalByOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "rentalId",
        type: "uint256",
      },
    ],
    name: "completeRentalByRenter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getTermsAndConditions",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "getTermsConfig",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "lateFeePerHour",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "maxLateFeeMultiplier",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "damageAssessmentPeriod",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "violationPenaltyRate",
            type: "uint256",
          },
        ],
        internalType: "struct CarRentalUpgradeable.TermsConfig",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address payable",
        name: "_chaindriveWallet",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "address payable",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "rentalFee",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "securityDeposit",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "platformFee",
        type: "uint256",
      },
    ],
    name: "initiateRental",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "pendingLateFees",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "rentals",
    outputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "address payable",
        name: "renter",
        type: "address",
      },
      {
        internalType: "address payable",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "rentalFee",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "securityDeposit",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "platformFee",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "renterConfirmed",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "ownerConfirmed",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "isCompleted",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type CarRentalUpgradeableConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: CarRentalUpgradeableConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class CarRentalUpgradeable__factory extends ContractFactory {
  constructor(...args: CarRentalUpgradeableConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(overrides || {});
  }
  override deploy(overrides?: NonPayableOverrides & { from?: string }) {
    return super.deploy(overrides || {}) as Promise<
      CarRentalUpgradeable & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(
    runner: ContractRunner | null
  ): CarRentalUpgradeable__factory {
    return super.connect(runner) as CarRentalUpgradeable__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): CarRentalUpgradeableInterface {
    return new Interface(_abi) as CarRentalUpgradeableInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): CarRentalUpgradeable {
    return new Contract(
      address,
      _abi,
      runner
    ) as unknown as CarRentalUpgradeable;
  }
}
